import { api } from '../lib/api';

export interface PrintJob {
  id: number;
  kind: string;
  templateKey: string | null;
  refType: string | null;
  refId: number | null;
  copies: number;
  status: string;
  notes: string | null;
  createdAt: string;
  createdByUserId: number | null;
}

export const printApi = {
  list: (params?: { kind?: string; status?: string }) => {
    const sp = new URLSearchParams();
    if (params?.kind) sp.set('kind', params.kind);
    if (params?.status) sp.set('status', params.status);
    const q = sp.toString();
    return api.get<{ jobs: PrintJob[] }>('/print/jobs' + (q ? '?' + q : ''));
  },
  get: (id: number) => api.get<PrintJob & { mediaId?: number; printerId?: number; printedAt?: string }>(`/print/jobs/${id}`),
  create: (data: { templateKey: string; refType: string; refId?: number; copies?: number; printerId?: number; notes?: string; options?: Record<string, unknown> }) =>
    api.post<{ id: number; mediaId: number; status: string }>('/print/jobs', data),
  reprint: (id: number) => api.post<{ id: number; status: string }>(`/print/jobs/${id}/reprint`),
  /** Open PDF in new tab (uses credentials) */
  openPdf: async (id: number): Promise<void> => {
    const res = await api.raw(`/print/jobs/${id}/download`, { method: 'GET' });
    if (!res.ok) throw new Error('Kunde inte hämta PDF');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
};
